import React, { useEffect, useState } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';

import { Modal } from '@unimed-fesp/components';

// #region Assets
import { ReactComponent as Replay } from '../../../assets/icons/replay.svg';
import { ReactComponent as Upload } from '../../../assets/icons/upload.svg';
import { ReactComponent as Cancel } from '../../../assets/icons/cancel-24px.svg';
import { ReactComponent as DoubleArrow } from '../../../assets/icons/doubleArrow.svg';
// #endregion

import { legacyRoutes } from '../../../routes/legacyRoutes';
import { Creators as ListaActions } from '../../../store/ducks/lista';
import { MovimentacaoListaEnum } from '../../../enums';
import history from '../../../services/history';

import Card from '../../molecules/Card';
import { ModalContentWrapper } from '../../molecules/Modal';

import theme from '../../../styles/theme';
import { Container, ContentText, ContainerInativos } from './styles';
import ModalInclusaoUspLista from '../ModalInclusaoUspLista';

function ModalAcaoLista({ isOpen, onClick, handleClick }) {
  const { usuario } = useSelector((state) => state.auth);
  const lista = useSelector((state) => state.lista);
  const dispatch = useDispatch();
  const [isInclusaoUspOpen, setIsInclusaoUspOpen] = useState(false);

  function handleCreate() {
    dispatch(ListaActions.postListaInativasRequest(usuario));
  }

  function toggleModalInclusaoUspLista() {
    setIsInclusaoUspOpen(!isInclusaoUspOpen);
  }

  useEffect(() => {
    if (!lista?.loading && lista?.success && lista?.create) {
      history.push(`/novo/listainativo/${lista?.response?.idLista}`);
    }
  }, [lista]);

  return (
    <Modal
      width={1000}
      height={350}
      isOpen={isOpen}
      onClick={onClick}
      header={<>nova lista manual de movimentação</>}
    >
      <ModalContentWrapper>
        <ContentText>
          Que tipo de lista de movimentação você deseja incluir?
        </ContentText>
        <Container>
          {usuario.codigoContratante == "76811" ? (
            <><Card
              text="inclusão"
              onClick={toggleModalInclusaoUspLista}
            >
              <Upload fill={theme.grayDefault} />
            </Card>
                <ModalInclusaoUspLista
                  isOpen={isInclusaoUspOpen}
                  onClick={toggleModalInclusaoUspLista} /></>
          ) : <a
            href={legacyRoutes.CadastrarLista.url}
            style={{
              textDecoration: 'none',
            }}
          >
            <Card text="inclusão">
              <Upload fill={theme.grayDefault} />
            </Card>
          </a>}
          <a
            href={legacyRoutes.CadastrarLista.url}
            style={{
              textDecoration: 'none',
            }}
          >
            <Card text="alteração">
              <Replay fill={theme.grayDefault} />
            </Card>
          </a>
          <a
            href={legacyRoutes.CadastrarLista.url}
            style={{
              textDecoration: 'none',
            }}
          >
            <Card text="exclusão">
              <Cancel fill={theme.grayDefault} />
            </Card>
          </a>
          <Card
            text="transferência"
            onClick={() =>
              handleClick(MovimentacaoListaEnum.returnIdForName.Transferencia)
            }
          >
            <DoubleArrow fill={theme.grayDefault} />
          </Card>
          <ContainerInativos>
            <Card text="inativo" onClick={handleCreate}>
              <FiAlertTriangle color={theme.grayDefault} />
            </Card>
          </ContainerInativos>
        </Container>
      </ModalContentWrapper>
    </Modal>
  );
}

export default ModalAcaoLista;
